export enum FileTypeEnum {
    IMAGE = 'IMAGE',
    VIDEO = 'VIDEO',
    VOICE = 'VOICE',
    DOCUMENT = 'DOCUMENT',
    LOCATION = 'LOCATION',
}